// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "footer[data-v-a6fa6040]{height:1.3em;text-align:center}.blue-container[data-v-a6fa6040]{border-radius:5px;background-color:#0078b6}", ""]);
// Exports
module.exports = exports;
